import React, { useEffect, useState, useContext } from 'react';
import {
  Box, Button, Chip, CircularProgress, Dialog, DialogContent,
  Grid, IconButton, makeStyles, Tooltip
} from '@material-ui/core';
import ClearIcon from '@material-ui/icons/Clear';
import CloseIcon from '@material-ui/icons/Close';
import FlipCameraAndroidIcon from '@material-ui/icons/FlipCameraAndroid';
import LabelImportantIcon from '@mui/icons-material/LabelImportant'
import NavigateBeforeIcon from '@material-ui/icons/NavigateBefore';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import TuneIcon from '@material-ui/icons/Tune';
import { Alert } from '@material-ui/lab';
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from '@material-ui/pickers';
import { es } from 'date-fns/locale';
import DateFnsUtils from '@date-io/date-fns';
import {
  formatDateObjToSlash,
  getControlDay,
} from '../../helpers/common';
import Container from '../Elements/Container';
import TopNav from '../common/TopNav';
import Filter from './Filter';

import UserContext from '../../context/UserContext';
import { getChipLabel } from './helpers';
import DualChartAdvanced from './DualChartAdvanced';
import cloneDeep from 'lodash/cloneDeep';
//Servicios
import { getInstantV2 } from '../../services/meters';
import { getUserInfoFromLocalStorage } from '../../services/auth';


const useStyles = makeStyles(theme => ({
  dateContainer: {
    padding: '0 8px',
    color: theme.palette.common.white,
    fontSize: 16,
    '& .MuiButtonBase-root': {
      color: theme.palette.common.white,
    },
    '& .MuiInputBase-root': {
      color: theme.palette.common.white,
      width: 125,
    },
    '& .MuiInputBase-input': {
      textAlign: 'center',
    },
    '@media (max-width: 700px)': {
      display: 'none',
    },
  },
  date: {
    '& .MuiInputBase-root': {
      width: 160,
    },
  },
  nextDayBtn: {
    '&.Mui-disabled': {
      opacity: '0.5',
    },
  },
  btn: {
    margin: theme.spacing(2, 1),
    '& .MuiButton-label': {
      textTransform: 'none',
      // fontSize: 11,
      fontWeight: 700,
      color: theme.palette.primary.main,
    },
    '&.MuiButton-root': {
      backgroundColor: theme.palette.common.white,
    },
  },
  btnRefresh: {
    '&.MuiButton-root': {
      height: '30px',
      marginTop: '16px',
      backgroundColor: theme.palette.common.white,
    },
    '& .MuiButton-label': {
      textTransform: 'none',
      paddingLeft: '5px',
      // fontSize: 11,
      fontWeight: 700,
      color: theme.palette.primary.main,
    },
    '@media (max-width: 700px)': {
      marginBottom: '10px',
      marginRight: '10px',
    },
  },
  devicesText: {
    marginLeft: theme.spacing(6),
    '@media (max-width: 700px)': {
      marginLeft: theme.spacing(0),
      marginRight: theme.spacing(0),
    },
  },
  chip: {
    margin: theme.spacing(0.5),
    '@media (max-width: 700px)': {
      width: '200px',
    },
  },
  alert: {
    '@media (max-width: 700px)': {
      marginLeft: theme.spacing(0),
    },
  },
  tuneIcon: {
    '& .MuiSvgIcon-root': {
      fontSize: '1.5em',
      paddingTop: theme.spacing(0.5),
    },
  },
  circular: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: '15px',
  },
  nodosBoxesLabels: {
    marginLeft: theme.spacing(1),
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    flexWrap: "wrap",
    '@media (max-width: 700px)': {
      flexDirection: 'column',
      alignItems: 'center',
    },
  },
  dialogStyle: {
    '& .MuiDialog-paperScrollPaper': {
      height: '100vh'
    },
    '& .MuiDialogContent-root': {
      '@media (max-width: 900px)': {
        padding: '2px'
      },
    },
    '& .MuiDialog-paper': {
      '@media (max-width: 600px)': {
        margin: '0px'
      },
    },
    '& .MuiDialog-paperFullWidth': {
      '@media (max-width: 600px)': {
        width: '100%'
      },
    },
  }
}));

export default function InstantAdvanced() {
  const classes = useStyles();
  const { plan } = useContext(UserContext);
  const [filterOptions, setFilterOptions] = useState(() => cloneDeep({
    groups: [
      {
        title: 'Grafico Principal',
        disabled: false,
        dataSets: [],
        selectedInitialDate: new Date(Date.now() - 24 * 60 * 60 * 1000),
        selectedEndDate: new Date(),
      }
    ],
  }))
  const [filterPanel, setFilterPanel] = useState(true);
  const [showErrorAlert, setShowErrorAlert] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const [limitDate, setLimitDate] = useState({
    inst_days_historic: 10,
  });
  const [instantData, setInstantData] = useState([]);
  const [tz, setTz] = useState('America/Argentina/Buenos_Aires');
  const [VARS_CATALOGO, setVARS_CATALOGO] = useState([]);

  //Valida el timeZone
  useEffect(() => {
    setTz(plan?.info?.tz)
  }, [plan])

  const getBaseInstantCatalog = () => {
    return plan?.sections?.["INSTANTANEOS"]?.filter(item => item.enabled) || [];
  }

  const buildVarsCatalog = (customVars = []) => {
    const catalogoLocal = getBaseInstantCatalog();
    const catalogMap = new Map();

    [...catalogoLocal, ...customVars].forEach(item => {
      if (!item?.key) {
        return;
      }
      const itemKey = `${item?.group?.key || 'default'}-${item.key}`;
      if (!catalogMap.has(itemKey)) {
        catalogMap.set(itemKey, item);
      }
    });

    return Array.from(catalogMap.values());
  }

  const handleVarsCatalogChange = (customVars = []) => {
    setVARS_CATALOGO(buildVarsCatalog(customVars));
  }

  useEffect(() => {
    const catalogoLocal = plan?.sections?.["INSTANTANEOS"]?.filter(item => item.enabled) || [];
    setVARS_CATALOGO(catalogoLocal);
  }, [plan])

  //Red alert
  useEffect(() => {
    if (showErrorAlert) {
      setTimeout(() => {
        setShowErrorAlert(false);
      }, 7000);
    }
  }, [showErrorAlert])
  //Aca determino cuantos dias hacia atras puede pedir data el usuario  pra evitar consultas inenecesarias al back.
  useEffect(() => {
    setLimitDate(getUserInfoFromLocalStorage());
  }, []);

  const togglePanel = () => {
    setFilterPanel(!filterPanel);
  };

  const handleSubmit = async filter => {
    if (filter) {
      setFilterPanel(false);
      setErrorMessage('');
      setFilterOptions(filter);
      let devices = [];
      const fetchPromises = [];
      filter.groups.forEach((group, groupIndex) => {
        const from = formatDateObjToSlash(group.selectedInitialDate);
        const to = formatDateObjToSlash(group.selectedEndDate);
        group.dataSets.forEach((dataset, datasetIndex) => {
          let url = '';
          let selectedNodeId = dataset?.devices[0]?.id;
          let selectedTagId = dataset?.devices[0]?.label_id;
          let variable = dataset?.customVarsCatalog?.find(item => item.key === dataset.variable)
            || VARS_CATALOGO?.find(item => item.key === dataset.variable);
          //Si el dataset es un automate.(solamente tendra un dispositivo cargado)
          if (dataset?.devices.length > 0) {
            if (dataset?.devices[0]?.automates.length > 0) {
              variable = dataset?.customVarsCatalog?.find((item) => {
                if (item?.group?.key === dataset?.devices[0]?.automates[0]?.llave && item.key === dataset.variable) {
                  return item
                }
              }) || VARS_CATALOGO?.find((item) => {
                if (item?.group?.key === dataset?.devices[0]?.automates[0]?.llave && item.key === dataset.variable) {
                  return item
                }
              });
            }
          }
          dataset.variableName = variable?.name
          dataset.granularity = parseInt(dataset?.granularity);
          //Es una variable personalizada se modifica la url
          if (variable?.client_var) {
            // filter=8499&filter=15531&vars=94E6868811B8+1,10&response_format=v2&from=1/2/2025&to=28/2/2025
            url += `filter=${selectedNodeId}`
            url += `&vars=${variable?.group?.key}`
            url += `+${variable?.key}`
            url += `&response_format=v2`;
            url += `&from=${from}&to=${to}`
          }
          else {
            // Asigna dispositivo con etiqueta si se seleccionó
            url += `filter=${selectedNodeId}`;
            if (selectedTagId) {
              url += `+${selectedTagId}`;
              let nameDevice = `${dataset?.devices[0]?.nombre} ${dataset?.devices[0]?.label_nombre}`
              devices.push(nameDevice)
            }
            else {
              let nameDevice = `${dataset?.devices[0]?.nombre}`
              devices.push(nameDevice)
            }
            // Asigna variable
            url += `&fields=${variable?.fields}`;
            // Asigna granularidad
            url += `&granularity=${parseInt(dataset?.granularity)}`;
            // Asigna fecha desde/hasta
            url += `&from=${from}&to=${to}`;
            url += `&response_format=v2`;
            // Asigna franja horaria
            url += dataset.timeslots ? `&timeslots=${dataset.timeslots}` : '';
            // Si selecciono variable por fase la asigna
            url += filter.showPhase ? `&showPhase=true` : '';
          }
          fetchPromises.push(
            fetchInstant(
              url,
              dataset,
              groupIndex,
            )
          );
        })
      });
      setLoading(true);
      try {
        const results = await Promise.all(fetchPromises);
        const successfulResults = results.filter(data => data !== null);
        const groupedArray = Object.values(
          successfulResults.reduce((acc, item) => {
            if (!acc[item.groupIndex]) {
              acc[item.groupIndex] = []; // Inicializa un nuevo grupo si no existe
            }
            acc[item.groupIndex].push(item); // Agrega el objeto al grupo correspondiente
            return acc;
          }, {})
        );
        setInstantData(groupedArray)
        if (successfulResults.length === 0) {
          // Todas las solicitudes fallaron
          setErrorMessage('Ha ocurrido un error');
          setShowErrorAlert(true);
          setInstantData([]);
        }
        else {
          // Mezclar los datos exitosos
          const mergedData = successfulResults.reduce((acc, data) => acc.concat(data), []);
          setInstantData(mergedData);
        }
      }
      catch (error) {
        console.error('Error al obtener datos:', error);
        setInstantData([]);
      }
      finally {
        setLoading(false);
      }
    }
  };

  const fetchInstant = async (
    url,
    dataset,
    groupIndex,
  ) => {
    //hace esto por cada dataset
    try {
      const res = await getInstantV2(url);
      if (res.data.error) {
        return []; // Retorna un array vacío si hay error
      } else {
        setShowErrorAlert(false);
        let data = res.data[0]?.data;
        let medidores = []
        if (res.data[0]?.medidores) {
          medidores = [...res.data[0]?.medidores]
        }
        let resData = {
          ...dataset,
          data,
          groupIndex,
          medidores
        }

        return resData;
      }
    } catch (error) {
      setInstantData([]);
      if (error.response) {
        if (error.response.status === 404) {
          setErrorMessage(
            `No se encontraron datos para el período ${dataset.alias}.`
          );
        } else {
          setErrorMessage(`El dataset ${dataset.alias} devolvió un error.`);
        }
      } else {
        setErrorMessage(`Ocurrió un error inesperado`);
      }
      setShowErrorAlert(true);
      return []; // Retorna un array vacío en caso de error
    }
  };

  const handleClose = () => {
    setFilterPanel(false);
  };

  const isFuture = (selectedEndDate) => {
    const today = new Date();
    const currentDay = today.getDay()
    const currentMonth = today.getMonth();
    const currentYear = today.getFullYear();

    return selectedEndDate?.getDay() === currentDay && selectedEndDate?.getMonth() === currentMonth && selectedEndDate?.getFullYear() === currentYear
  };

  function decrementPeriod(index) {
    let filter_key = { ...filterOptions };
    const initialDate = new Date(filter_key.groups[index].selectedInitialDate);
    const endDate = new Date(filter_key.groups[index].selectedEndDate);
    const aux = endDate?.getTime() - initialDate?.getTime();
    const difference = Math.ceil(aux / (24 * 60 * 60 * 1000));
    initialDate.setDate(initialDate.getDate() - difference);
    endDate.setDate(endDate.getDate() - difference);
    filter_key.groups[index].selectedInitialDate = initialDate;
    filter_key.groups[index].selectedEndDate = endDate;
    setFilterOptions({
      ...filter_key
    });
    handleSubmit({
      ...filter_key
    });
  }

  function incrementPeriod(index) {
    let filter_key = { ...filterOptions };
    const initialDate = new Date(filter_key.groups[index].selectedInitialDate);
    const endDate = new Date(filter_key.groups[index].selectedEndDate);
    const aux = endDate.getTime() - initialDate.getTime();
    const difference = Math.ceil(aux / (1000 * 3600 * 24));
    initialDate.setDate(initialDate.getDate() + difference);
    endDate.setDate(endDate.getDate() + difference);
    filter_key.groups[index].selectedInitialDate = initialDate;
    filter_key.groups[index].selectedEndDate = endDate;
    setFilterOptions({
      ...filter_key
    });
    handleSubmit({
      ...filter_key
    });
  }


  return (
    <>
      <TopNav
        titulo="Analisis"
        subtitulo="| Instantáneos"
        changeTitleStyleFlex={true}
      >
        <Grid container justifyContent="flex-end">
          {limitDate && (
            <Box
              className={classes.dateContainer}
              display="flex"
              justifyContent="center"
            >

              {filterOptions.groups.map((group, groupIndex) => {
                if (group.dataSets?.length > 0) {
                  return (
                    <>
                      <IconButton
                        aria-label="período anterior"
                        onClick={() => decrementPeriod(groupIndex)}
                        disabled={loading}
                      >
                        <NavigateBeforeIcon />
                      </IconButton>
                      <MuiPickersUtilsProvider locale={es} utils={DateFnsUtils}>
                        <KeyboardDatePicker
                          className={classes.date}
                          readOnly={true}
                          autoOk
                          disableToolbar
                          variant="inline"
                          format="dd/MM/yyyy"
                          margin="normal"
                          value={filterOptions.groups[groupIndex].selectedInitialDate}
                          minDate={getControlDay(
                            new Date(),
                            limitDate?.menu?.inst_days_historic
                          )}
                          maxDate={new Date()}
                          maxDateMessage=""
                          minDateMessage=""
                          KeyboardButtonProps={{
                            'aria-label': 'cambiar fecha',
                            style: { marginLeft: '10px' }, // o la distancia que quieras

                          }}
                          InputProps={{
                            disableUnderline: true,
                            readOnly: true,
                          }}
                        />
                      </MuiPickersUtilsProvider>

                      <MuiPickersUtilsProvider locale={es} utils={DateFnsUtils}>
                        <KeyboardDatePicker
                          readOnly={true}
                          className={classes.date}
                          autoOk
                          disableToolbar
                          variant="inline"
                          format="dd/MM/yyyy"
                          margin="normal"
                          value={filterOptions.groups[groupIndex].selectedEndDate}
                          KeyboardButtonProps={{
                            'aria-label': 'cambiar fecha',
                            style: { display: 'none' }, // Oculta el ícono del calendario
                          }}
                          InputProps={{
                            disableUnderline: true,
                            readOnly: true,
                          }}
                          maxDateMessage=""
                          minDateMessage=""
                        />
                      </MuiPickersUtilsProvider>
                      <IconButton
                        className={classes.nextDayBtn}
                        aria-label="período siguiente"
                        onClick={() => incrementPeriod(groupIndex)}
                        disabled={isFuture(group.selectedEndDate) || loading}
                      >
                        <NavigateNextIcon />
                      </IconButton>
                    </>
                  )
                } else {
                  return null
                }
              })}

            </Box>
          )}

          <Button
            className={classes.btn}
            type="button"
            onClick={togglePanel}
            size="small"
            startIcon={filterPanel ? <ClearIcon /> : <TuneIcon />}
          >
            | Filtrar
          </Button>

          {/* Boton refresh */}
          <Tooltip
            title="Última consulta."
            arrow
          >
            <Button
              className={classes.btnRefresh}
              type="button"
              onClick={() => handleSubmit(filterOptions)}
              // size='small'
              startIcon={<FlipCameraAndroidIcon />}
            ></Button>
          </Tooltip>

        </Grid>
      </TopNav>

      <Dialog
        className={classes.dialogStyle}
        open={filterPanel}
        onClose={handleClose}
        aria-labelledby="form-dialog-title"
        fullWidth
        maxWidth="lg"
        disableScrollLock
      >
        <DialogContent>
          <Filter
            handleClose={handleClose}
            onSubmit={handleSubmit}
            initialFilter={filterOptions}
            varsCatalog={VARS_CATALOGO}
            handleVarsCatalogChange={handleVarsCatalogChange}
          />
        </DialogContent>
      </Dialog>

      <Container>
        {showErrorAlert ? (
          <Box className={classes.alert}>
            <Alert
              severity="error"
              action={
                <IconButton
                  aria-label="close"
                  // color='error'
                  size="small"
                  onClick={() => {
                    setShowErrorAlert(false);
                  }}
                >
                  <CloseIcon fontSize="inherit" />
                </IconButton>
              }
            >
              {errorMessage}
            </Alert>
          </Box>
        ) : null}

        {filterOptions.groups[0].dataSets.length > 0 && (
          <>
            <Box className={classes.nodosBoxesLabels}>
              <p className={classes.devicesText}>Gráfico principal:</p>
              {filterOptions.groups[0].dataSets.map((dataset, indx) => (
                <Box key={indx} >
                  <Chip
                    className={classes.chip}
                    key={indx}
                    icon={<LabelImportantIcon style={{ fontSize: '18px' }} />}
                    label={getChipLabel(dataset)}
                    clickable
                    color="primary"
                    onClick={() => setFilterPanel(true)}
                  />
                </Box>
              ))}
            </Box>
            <Box className={classes.nodosBoxesLabels}>
              {
                filterOptions?.groups[1]?.dataSets?.length > 0 &&
                <p className={classes.devicesText}>Gráfico secundario:</p>
              }
              {
                filterOptions?.groups[1]?.dataSets?.map((dataset, index) => (
                  <Box key={index}>
                    <Chip
                      className={classes.chip}
                      key={index}
                      icon={<LabelImportantIcon style={{ fontSize: '18px' }} />}
                      label={getChipLabel(dataset)}
                      clickable
                      color="secondary"
                      onClick={() => setFilterPanel(true)}
                    />
                  </Box>
                ))}
            </Box>
          </>
        )}

        {(filterOptions.groups[0].dataSets?.length === 0) && (
          <Alert className={classes.alert} severity="info">
            Bienvenido a Instantáneos. En esta sección podrá consultar la
            información de consumos instantáneos de sus dispositivos. Para
            comenzar haga click en el botón
            <span className={classes.tuneIcon}>
              <TuneIcon />
            </span>
            , ingrese los parámetros y haga click en CONSULTAR.
          </Alert>
        )}

        {loading ? (
          <div className={classes.circular}>
            <CircularProgress />
          </div>
        ) : (
          <>
            {instantData && (
              <DualChartAdvanced
                tz={tz}
                chartData={instantData}
                filter={filterOptions?.groups}
              />
            )}
          </>
        )}
      </Container>
    </>
  );
}
